var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1574 17.4544C17.0015 17.6516 16.7166 17.6926 16.5261 17.5712L12.1022 14.3322C11.9814 14.2371 11.8483 14.0775 11.7453 13.8909C11.6406 13.701 11.583 13.5121 11.583 13.3654V6.28725C11.583 6.08048 11.7827 5.86493 12.0756 5.86493H13.5406C13.7725 5.86493 13.9629 6.05532 13.9629 6.28725V11.8659C13.9629 12.1374 14.0622 12.4192 14.1931 12.6568C14.3249 12.896 14.5046 13.1194 14.6974 13.2691L14.6973 13.2692L14.7053 13.275L17.9429 15.6079C18.1384 15.7637 18.1773 16.0771 18.0306 16.2661L18.0305 16.266L18.0262 16.2719L17.1574 17.4544ZM12.9827 25.225C6.23049 25.225 0.775 19.7695 0.775 13.0173C0.775 6.26409 6.23148 0.775 12.9827 0.775C19.7349 0.775 25.225 6.26508 25.225 13.0173C25.225 19.7685 19.7359 25.225 12.9827 25.225ZM12.9827 3.32894C7.66794 3.32894 3.36353 7.709 3.36353 13.0184C3.36353 18.3305 7.67061 22.6376 12.9827 22.6376C18.2921 22.6376 22.6722 18.3332 22.6722 13.0184C22.6722 7.70631 18.2948 3.32894 12.9827 3.32894Z",
    fill: "white",
    stroke: "#233F39",
    strokeWidth: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClock);
export default __webpack_public_path__ + "static/media/whiteClock.aa8bd5270f24fb49066ba1ded9b0624a.svg";
export { ForwardRef as ReactComponent };